import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Button from './Button';
import { getProductThumbnailUrl } from '@/utils/imageUtils';

const ConfirmReceiptDialog = ({ isOpen, onClose, onConfirm, order, isLoading }) => {
  const { t } = useTranslation();

  if (!isOpen || !order) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="w-[311px] bg-white rounded-xl inline-flex flex-col justify-start items-center overflow-hidden">
        <div className="self-stretch px-6 pt-8 pb-6 flex flex-col justify-start items-center gap-2">
          <div className="w-12 h-12 relative bg-white border border-[#DDDDDD] rounded overflow-hidden">
            <img 
              className="w-12 h-12 left-0 top-0 absolute mix-blend-darken" 
              src={getProductThumbnailUrl(order.listing?.product?.images?.[0]?.url)} 
              alt={order.listing?.product?.localizedName || "Product"} 
            />
          </div>
          <div className="self-stretch text-center text-[#111111] text-lg font-bold leading-[27px]">
            {t('orders.confirmReceipt.title')}
          </div>
          <div className="self-stretch text-[#666666] text-sm font-normal leading-[21px]">
            <Trans i18nKey="orders.confirmReceipt.description" components={{ br: <br />}} />
            <br/>
            <br/>
            {t('orders.confirmReceipt.productName')}: {order.listing?.product?.localizedName || ""}
          </div>
        </div>
        <div className="self-stretch px-6 pb-6 bg-white flex flex-col justify-center items-center">
          <div className="self-stretch inline-flex justify-start items-center gap-3">
            <Button
              variant="default"
              size="m"
              className="flex-1 h-10"
              onClick={onClose}
            >
              {t('common.cancel')}
            </Button>
            <Button
              variant="primary"
              size="m"
              className="flex-1 h-10"
              onClick={() => onConfirm(order.id)}
              disabled={isLoading}
            >
              {t('orders.confirmReceipt.confirm')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmReceiptDialog; 
